class Contact {
  constructor(el) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
      this.initDatePicker();
    }
  }

  event() {
    const $radios = $('.js-contact-type input[type="radio"]');

    function toggleExtra() {
      $('[data-id="js-contact-repair"], [data-id="js-contact-reserve"]').hide();

      const value = $('.js-contact-type input[type="radio"]:checked').val() || '';

      if (value === '来店予約') {
        $('[data-id="js-contact-reserve"]').show();
        // 来店予約が選択されたら、日時ピッカーを再初期化
        this.initDatePicker();
      }

      if (value === '修理について') {
        $('[data-id="js-contact-repair"]').show();
      }
    }

    $radios.on('change', toggleExtra.bind(this));
    toggleExtra.call(this);
  }

  initDatePicker() {
    // data-id="js-contact-reserve" 内のreserve_dateフィールドを探す（Contact Form 7の複数のパターンに対応）
    // パターン1: name属性にreserve_dateが含まれる
    // パターン2: wpcf7-form-control-wrap-reserve_dateクラス内のinput
    // パターン3: 直接name="reserve_date"
    let $reserveDateInput = $('[data-id="js-contact-reserve"] input[name="reserve_date"]');
    if ($reserveDateInput.length === 0) {
      $reserveDateInput = $('[data-id="js-contact-reserve"] input[name*="reserve_date"]');
    }
    if ($reserveDateInput.length === 0) {
      $reserveDateInput = $('[data-id="js-contact-reserve"] .wpcf7-form-control-wrap-reserve_date input[type="text"]');
    }
    
    if ($reserveDateInput.length > 0 && typeof flatpickr !== 'undefined') {
      const inputElement = $reserveDateInput[0];
      
      // 既に初期化されている場合は破棄
      if (inputElement._flatpickr) {
        inputElement._flatpickr.destroy();
      }

      // 日本語ロケール設定
      flatpickr.localize({
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ['日', '月', '火', '水', '木', '金', '土'],
          longhand: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
        },
        months: {
          shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
      });

      // Flatpickrを初期化（1時間単位で時間選択）
      flatpickr(inputElement, {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        locale: {
          firstDayOfWeek: 0,
          weekdays: {
            shorthand: ['日', '月', '火', '水', '木', '金', '土'],
            longhand: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
          },
          months: {
            shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          }
        },
        minDate: 'today',
        allowInput: false,
        minuteIncrement: 60, // 1時間単位（10:00, 11:00, 12:00...17:00）
        defaultHour: 10,
        defaultMinute: 0,
        minTime: '10:00',
        maxTime: '17:00',
        // 土日祝も選択可能（disableオプションを指定しない）
        onReady: function(selectedDates, dateStr, instance) {
          // カレンダーが表示されたときの処理
        }
      });
    }
  }
}
class Order {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-tab-trigger button').on('click', function(e){
      e.preventDefault();
      $(this).addClass('is-active').siblings().removeClass('is-active');
      $('.js-tab-content .js-kinds-sec').eq($(this).index()).show();
      $('.js-tab-content .js-kinds-sec').eq($(this).index()).siblings().hide();
    });
  }
}

let c1_choice = '';

class Simulation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.restoration();
      this.resultPrice();
      this.tabChangeEvent();
      this.choiceEvent();
      this.choiceEventbyou();
      this.choiceEventSenaka();
      this.choiceEventKashime();
      this.submitBtnActive();
      this.postalCodeSearch();
    }
  }

  submitBtnActive() {
    setInterval(() => {
      let flag = true;
      $('.js-choice-wrap button').each(function(){
        if($(this).hasClass('is-active') == false) {
          flag = false;
          return;
        }
      })
  
      if(!flag) {
        $('.js-submit-btn').prop('disabled', true).removeClass('is-active');
        $('.js-submit-caution').show();
      } else {
        $('.js-submit-btn').prop('disabled', false).addClass('is-active');
        $('.js-submit-caution').hide();
      }
    }, 500);
  }

  // 背中タブ: 溝あり/なし と 色の両方が選ばれているときだけ is-active
  updateSenakaTabActive() {
    const params = this.getParams();
    const hasMizo = params['c6-radio'] !== undefined && params['c6-radio'] !== '';
    const hasColor = params['c6'] !== undefined && params['c6'] !== '';
    const $tab = $('.js-choice-wrap button[data-id="c6"]');

    if(hasMizo && hasColor) {
      $tab.addClass('is-active');
    } else {
      $tab.removeClass('is-active');
    }
  }

  choiceEvent(){
    // preserve "this" for use inside callback
    const self = this;
    $('.js-choice').each(function(){
      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      let $choiceBtns = $(this).find('.js-choice-btn');
      $choiceBtns.each(function(index){
        $(this).on('click', function(){

          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.resultPrice();
          self.restoration();

          if (id === 'c10') {
            const type = $(this).data('type');
            self.changeEdgeMask(type);
          }
        });
      });
    });
  }

  choiceEventSenaka() {
      
    // preserve "this" for use inside callback
    const self = this;

    const params = this.getParams();

    if(params['c6-radio'] && params['c6-radio'] !== '') {
      $('[data-id="c6-radio"] input').eq(params['c6-radio']).prop('checked', true);
      if(params['c6-radio'] === '1') {
        $('.js-groove-off').show();
        $('.js-grooved-light').hide();
      } else {
        $('.js-groove-off').hide();
        $('.js-grooved-light').show();
      }

      self.choiceEventSenakaResult();
    }

    if(params['c6'] && params['c6'] !== '') {
      const id = $('.js-choice-senaka').attr('data-id');

      const $el = $('.js-choice-senaka .js-choice-btn').eq(params['c6']);

      // 共通メソッドを使用してスタイルを適用
      const $target = $(`#${id}`);
      const color = $el.attr('data-color') ? $el.attr('data-color') : 'none';
      const mixBlendMode = $el.attr('data-mix-blend-mode') ? $el.attr('data-mix-blend-mode') : 'inherit';
      const img = $el.attr('data-img') ? `url(${$el.attr('data-img')})` : 'none';

      if (color) $target.css('background-color', color);
      if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
      if (img) $target.css('background-image', img);

      if (id === 'c1') c1_choice = $el.find('p').text();

      $el.addClass('is-choice');
      $el.siblings().removeClass('is-choice');

      self.choiceEventSenakaResult();
    }

    // 溝・色の両方が揃っているときだけタブをアクティブに
    self.updateSenakaTabActive();

    $('.js-choice-senaka').each(function(){
      $(this).find('.js-choice-radio').on('click', function(){
        const id = $(this).attr('data-id');
        $(this).data('off') ? $('.js-groove-off').show() : $('.js-groove-off').hide();
        $(this).data('off') ? $('.js-grooved-light').hide() : $('.js-grooved-light').show();
        $(this).data('off') ? $('.js-no-grooved').show() : $('.js-no-grooved').hide();
        self.url(id, $(this).index());
        self.updateSenakaTabActive();
        self.choiceEventSenakaResult();
      });

      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      let $choiceBtns = $(this).find('.js-choice-btn');
      $choiceBtns.each(function(index){
        $(this).on('click', function(){
          // 共通メソッドを使用してスタイルを適用
          const $target = $(`#${id}`);
          const color = $(this).attr('data-color') ? $(this).attr('data-color') : 'none';
          const mixBlendMode = $(this).attr('data-mix-blend-mode') ? $(this).attr('data-mix-blend-mode') : 'inherit';
          const img = $(this).attr('data-img') ? `url(${$(this).attr('data-img')})` : 'none';
    
          if (color) $target.css('background-color', color);
          if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
          if (img) $target.css('background-image', img);
    
          if (id === 'c1') c1_choice = $(this).find('p').text();
    
          // ボタンの状態を更新
          if($(this).hasClass('radiobox')) {
            $(this).find('input').prop('checked', true);
          } else {
            $(this).addClass('is-choice');
            $(this).siblings().removeClass('is-choice');
          }
    
          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.updateSenakaTabActive();
          self.resultPrice();
          self.restoration();
          self.choiceEventSenakaResult();
        });
      });
    });
  }

  replaceMaskImageFile($target, newFile) {
    let maskImage =
      $target.css('mask-image') || $target.css('-webkit-mask-image');
  
    if (!maskImage || maskImage === 'none') return;
  
    let currentUrl = maskImage
      .replace(/^url\(["']?/, '')
      .replace(/["']?\)$/, '');
  
    let newUrl = currentUrl.replace(/[^/]+$/, newFile);
  
    $target.css({
      'mask-image': `url("${newUrl}")`,
      '-webkit-mask-image': `url("${newUrl}")`
    });
  }

  changeEdgeMask(type) {
    if (type === 'heart') {
      this.replaceMaskImageFile($('#c5'), 'edge_black_heart.png');
      this.replaceMaskImageFile($('#c4'), 'separator_black_heart.png');
    } else {
      this.replaceMaskImageFile($('#c5'), 'edge_black.png');
      this.replaceMaskImageFile($('#c4'), 'separator_black.png');
    }
    this.setShapeParam('c10_shape', type);
  }

  toggleByouDefault($btn) {
    const img = $btn.attr('data-img') || '';
  
    // c12がノーマル（byou-img01.png）なら非表示
    // それ以外が選ばれたら表示
    if (img.includes('byou-img01.png')) {
      $('#c2-byou').css('opacity', 0);
    } else {
      $('#c2-byou').css('opacity', 1);
    }
  }

  setShapeParam(key, value) {
    if (this.isRestoring) return;
  
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, '', url);
  }
  
  choiceEventSenakaResult() {
    const params = this.getParams();
    const mizoTxt = `[${$('.js-choice-radio').eq(params['c6-radio']).find('.js-resultTxt').text()}]`;
    const colorTxt = mizoTxt + `${$('.js-choice-senaka .js-choice-btn').eq(params['c6']).find('.js-resultTxt').text()}`;

    $('.js-choice-result[data-id="c6"]').text(colorTxt);
  }

  choiceEventKashime() {
    // preserve "this" for use inside callback
    const self = this;

    const params = this.getParams();

    $('.js-choice-kashime').each(function(){

      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      $(this).find('.js-kanagu').on('click', function(){

        const correspondence = $(this).data('correspondence');

        $('.js-kashime').each(function(){
          if($(this).data('correspondence') === correspondence) {
            $(this).animate({opacity: 1}, 100);
            $(this).css('pointer-events', 'auto');
            if(correspondence != 'various-color') {
              $('.js-kashime-txt').hide();
              $(this).trigger('click');
            } else {
              $('.js-kashime-txt').show();
              $('.js-kashime[data-correspondence="various-color"]').eq(0).trigger('click');
            }
          } else {
            $(this).removeClass('is-choice');
            $(this).animate({opacity: 0.5}, 100);
            $(this).css('pointer-events', 'none');
          }
        });

        const radioId = $(this).attr('data-id');
        self.url(radioId, $(this).index());

        let img = $(this).attr('data-img') ? `url(${$(this).attr('data-img')})` : 'none';
        
        let $target = $(`#${id}`);
        if (img) $target.css('background-image', img);

        $('.js-kanagu').each(function(){
          // $(this)のどれかがcheckedなら
          if ($(this).find('input').is(':checked')) {
            $('.js-choice-wrap button[data-id="c11"]').addClass('is-active');
          }
        });

        self.choiceEventKashimeResult();
      });

      let $choiceBtns = $(this).find('.js-kashime-choice-btn');

      $choiceBtns.find('.js-kashime').each(function(index){
        $(this).on('click', function(){
          $('.js-kashime').removeClass('is-choice');
          $(this).addClass('is-choice');

          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.resultPrice();
          self.restoration();

          const correspondence = $(this).data('correspondence');

          $('.js-kashime').each(function(){
            if($(this).data('correspondence') === correspondence) {
              $(this).animate({opacity: 1}, 100);
              $(this).css('pointer-events', 'auto');
            } else {
              $(this).animate({opacity: 0.5}, 100);
              $(this).css('pointer-events', 'none');
            }
          });

          $('.js-kanagu').each(function(){
            if($(this).data('correspondence') === correspondence) {
              $(this).find('input').prop('checked', true);
            }
          });

          self.choiceEventKashimeResult();
        });
      });

      // ゴールド・真鍮黒の場合、背カンを「立ち上がり」に変更
      $('.js-kanagu, .js-kashime').on('click', function(){
        changeTachiagari($(this).data('correspondence'));
      });
    });

    if(params['c11'] && params['c11'] !== '') {
      const $btn = $('.js-choice-btn.js-kashime').eq(params['c11']);
      const correspondence = $btn.data('correspondence');
      $btn.addClass('is-choice');

      $('.js-kashime').each(function(){
        if($(this).data('correspondence') === correspondence) {
          $(this).animate({opacity: 1}, 100);
          $(this).css('pointer-events', 'auto');
        } else {
          $(this).animate({opacity: 0.5}, 100);
          $(this).css('pointer-events', 'none');
        }
      });
      self.choiceEventKashimeResult();
      
      changeTachiagari($btn.data('correspondence'));
    }

    if(params['c11-radio'] && params['c11-radio'] !== '') {
      $('[data-id="c11-radio"] input').eq(params['c11-radio']).prop('checked', true);
      const $radio = $('[data-id="c11-radio"]').eq(params['c11-radio']);
      const id = $('.js-choice-kashime').data('id');
      const img = $radio.attr('data-img') ? `url(${$radio.attr('data-img')})` : 'none';

      const $target = $(`#${id}`);
      
      if (img) $target.css('background-image', img);

      $('.js-choice-wrap button[data-id="c11"]').addClass('is-active');

      self.choiceEventKashimeResult();

      changeTachiagari($radio.data('correspondence'));
    }

    function changeTachiagari(correspondence) {
      if(correspondence === 'gold-color' || correspondence === 'shinchu-color') {
        $('.js-choice-btn.js-tachiagari').trigger('click');
        $('.js-sekan-caution').css('display', 'none');
        $('.js-choice-btn.js-tachiagari').siblings().animate({opacity: 0.5}, 300);
        $('.js-choice-btn.js-tachiagari').siblings().css('pointer-events', 'none');
      } else {
        $('.js-sekan-caution').css('display', 'block');
        $('.js-choice-btn.js-tachiagari').siblings().animate({opacity: 1}, 300);
        $('.js-choice-btn.js-tachiagari').siblings().css('pointer-events', 'auto');
      }
    }
  }

  choiceEventKashimeResult() {
    const params = this.getParams();
    const kanaguTxt = $('.js-kanagu').eq(params['c11-radio']).length > 0 ? `${$('.js-kanagu').eq(params['c11-radio']).find('.js-resultTxt').text()}` : '未選択';
    const kanaguPrice = $('.js-kanagu').eq(params['c11-radio']).length > 0 ? $('.js-kanagu').eq(params['c11-radio']).data('price') : '0';

    $('.js-individual-price[data-id="c11-radio"]').attr('data-price', kanaguPrice);
    $('.js-choice-result[data-id="c11-radio"]').text(kanaguTxt);
    $('.js-individual-price[data-id="c11-radio"]').text(`+${kanaguPrice.toLocaleString()}円`);

    const kashimeTxt = $('.js-kashime').eq(params['c11']).length > 0 ? `${$('.js-kashime').eq(params['c11']).find('.js-resultTxt').text()}` : '未選択';
    $('.js-choice-result[data-id="c11"]').text(kashimeTxt);

    const basePrice = Number($('.js-total-price').attr('data-base-price'));
    
    let totalPrice = basePrice;

    $('.js-individual-price').each(function(){
      const price = Number($(this).attr('data-price') || 0);
      totalPrice += price;
    });

    $('.js-total-price').text(`${totalPrice.toLocaleString()}`);
  }

  choiceEventbyou() {
    const self = this;
  
    $('.js-choice[data-id="c12"]').each(function(){
      $(this).find('.js-choice-btn').each(function(){
        $(this).on('click', function(){
          $('.js-choice[data-id="c12"] .js-choice-btn').removeClass('is-choice');
          $(this).addClass('is-choice');
  
          self.toggleByouDefault($(this));
        });
      });
    });
  }
  tabChangeEvent() {
    const self = this;

    $('.js-choice-wrap button').on('click', function(){
      let el = $(this);
      let choiceId = $(this).attr('data-id');
      
      self.tabChangeFunction(el, choiceId);
    });

    $('.js-prev-next-btn').on('click', function(){
      let el = $(`.js-choice-wrap button[data-id="${$(this).attr('data-id')}"]`);
      let choiceId = $(this).attr('data-id');

      self.tabChangeFunction(el, choiceId);
    });
  }

  tabChangeFunction(el, choiceId) {
    el.siblings().removeClass('is-choice');
    el.addClass('is-choice');

    $('.js-overview[data-id="' + choiceId + '"], .js-choice[data-id="' + choiceId + '"], .js-choice-senaka[data-id="' + choiceId + '"], .js-choice-kashime[data-id="' + choiceId + '"]').show();
    $('.js-overview[data-id!="' + choiceId + '"], .js-choice[data-id!="' + choiceId + '"], .js-choice-senaka[data-id!="' + choiceId + '"], .js-choice-kashime[data-id!="' + choiceId + '"]').hide();
  }

  // 選択されたボタンのスタイルを適用し、状態を更新する共通メソッド
  applyChoiceStyle(id, $btn, updateTab = false) {
    // $btnが存在しない場合は処理をスキップ
    if(!$btn || $btn.length === 0) {
      return;
    }
    
    if(id !== 'c11' && id !== 'c11-radio' && id !== 'c6' && id !== 'c6-radio') {
      const $target = $(`#${id}`);
      const color = $btn.attr('data-color') ? $btn.attr('data-color') : 'none';
      const mixBlendMode = $btn.attr('data-mix-blend-mode') ? $btn.attr('data-mix-blend-mode') : 'inherit';
      const img = $btn.attr('data-img') ? `url(${$btn.attr('data-img')})` : 'none';

      
      if (color) $target.css('background-color', color);
      if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
      if (img != 'none') {
        $target.css('background-image', img);
        $target.css('background-color', '');
        $target.css('mask-image', 'none');
      } else {
        $target.css('background-image', 'none');
        $target.css('mask-image', $target.attr('data-mask'));
      }

      if (id === 'c1') c1_choice = $btn.find('p').text();
      if (id === 'c2') {
        const $byouTarget = $('#c2-byou');
      
        if (img != 'none') {
          $byouTarget.css({
            'background-color': '',
            'background-image': 'none',
            'mask-image': $byouTarget.attr('data-mask'),
            '-webkit-mask-image': $byouTarget.attr('data-mask')
          });
        } else {
          $byouTarget.css({
            'background-color': color,
            'mix-blend-mode': mixBlendMode,
            'background-image': 'none',
            'mask-image': $byouTarget.attr('data-mask'),
            '-webkit-mask-image': $byouTarget.attr('data-mask')
          });
        }
      }

      // ボタンの状態を更新
      if($btn.hasClass('radiobox')) {
        $btn.find('input').prop('checked', true);
      } else {
        $btn.addClass('is-choice');
        $btn.siblings().removeClass('is-choice');
      }

      // タブをアクティブにする（オプション）
      if (updateTab) {
        $(`.js-choice-wrap button[data-id="${id}"]`).addClass('is-active');
      }
    }
  }

  // URLパラメータの追加・更新
  url(id, index) {
    const url = new URL(window.location.href);
    url.searchParams.set(id, index);
    window.history.replaceState({}, '', url);
    $('.js-url').val(url.toString());
  }
  // URLパラメータから分解(?c1=3&c2=5&c3=3 → {c1: 3, c2: 5, c3: 3})
  getParams() {
    const url = new URL(window.location.href);
    // URLのクエリパラメータをオブジェクト化
    const params = {};
    for (const [key, value] of url.searchParams.entries()) {
      params[key] = value;
    }
    return params;
  }
  // URLパラメータから更新・復活
  restoration() {
    const params = this.getParams();
    this.isRestoring = true;
    
    if(Object.keys(params).length > 0) {
      // paramsオブジェクトをfor文で繰り返してキーと値を出力
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }
        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          
          // $choiceが見つからない場合はスキップ
          if($choice.length === 0) {
            continue;
          }
          
          let $btn;
          $choice.find(`.js-choice-btn`).each(function(index){
            if(index === Number(params[key])) {
              $btn = $(this);
            }
          });
          
          // $btnが見つかった場合のみapplyChoiceStyleを呼び出す
          if($btn && $btn.length > 0) {
            // クリックイベントをトリガーせず、直接状態を更新（タブもアクティブにする）
            this.applyChoiceStyle(key, $btn, true);
          }
        }
      }
    }
    if (params.c10_shape) {
      this.changeEdgeMask(params.c10_shape);
    }
  
    this.isRestoring = false;
  }
  // 金額を計算
  price() {
    const params = this.getParams();

    // 背中(c6): js-choice-senaka のためここで個別に反映
    if (params['c6'] !== undefined && params['c6'] !== '') {
      const $target = $(`.js-individual-price[data-id="c6"]`);
      const $choice = $('.js-choice-senaka[data-id="c6"]');
      const price = Number($choice.attr('data-price') || 0);
      $target.attr('data-price', price);
      $target.text(`+${price.toLocaleString()}円`);
    }

    if(Object.keys(params).length > 0) {
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }
        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          const $target = $(`.js-individual-price[data-id="${key}"]`);
          
          // c2〜c5までは、本体の色(c1)と同じ名前だったら0円（番号ではなく名前で比較）
          if (/^c[2-5]$/.test(key)) {
            const norm = (t) => (t || '').replace(/\s+/g, '').trim();
            const c1Name = norm($('.js-choice[data-id="c1"]').find('.js-choice-btn').eq(Number(params['c1'])).find('.js-resultTxt').text());
            const keyName = norm($choice.find('.js-choice-btn').eq(Number(params[key])).find('.js-resultTxt').text());
            if (c1Name !== '' && keyName !== '' && keyName === c1Name) {
              $target.attr('data-price', 0);
            } else {
              $target.attr('data-price', $choice.attr('data-price'));
            }
          } else {
            // c2〜c5以外の場合、初期値として$choiceのdata-priceを設定
            $target.attr('data-price', $choice.attr('data-price') || 0);
          }
          // 〆c2〜c5までは、c1と同じ数字だったら0円

          // 個別の.js-choice-btnにdata-priceがあればそれを使用
          const index = Number(params[key]);
          const individualPrice = $choice.find('.js-choice-btn').eq(index).attr('data-price');
          if(individualPrice) {
            $target.attr('data-price', individualPrice);
          }
          // 〆個別の.js-choice-btnにdata-priceがあればそれを使用

          const price = Number($target.attr('data-price') || 0);
          $target.text(`+${price.toLocaleString()}円`);
        }
      }
    }


    if($('.js-choice-result[data-id="c11"]').text() == 'ゴールド' || $('.js-choice-result[data-id="c11"]').text() == '真鍮黒') {
      $('.js-individual-price[data-id="c13"]').attr('data-price', 0);
      $('.js-individual-price[data-id="c13"]').text('+0円');
    }

    const basePrice = Number($('.js-total-price').attr('data-base-price'));
    
    let totalPrice = basePrice;

    $('.js-individual-price').each(function(){
      const price = Number($(this).attr('data-price') || 0);
      totalPrice += price;
    });

    $('.js-total-price').text(`${totalPrice.toLocaleString()}`);
  }
  // 選んだ色・装飾をご注文内容に反映
  result() {
    const params = this.getParams();

    if(Object.keys(params).length > 0) {
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }

        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          const $result = $(`.js-choice-result[data-id="${key}"]`);
          
          $result.text($choice.find('.js-resultTxt').eq(params[key]).text());
        }
      }
    }
  }
  resultPrice() {
    this.price();
    this.result();
  }

  // 郵便番号検索機能
  postalCodeSearch() {
    const $postalCodeInput = $('.p-postal-code');
    const $addressInput = $('.p-region');

    if ($postalCodeInput.length === 0 || $addressInput.length === 0) {
      return;
    }

    $postalCodeInput.on('blur', function() {
      const postalCode = $(this).val().replace(/[^\d]/g, '');
      
      // 郵便番号が7桁の場合のみ検索
      if (postalCode.length === 7) {
        $.ajax({
          url: 'https://zipcloud.ibsnet.co.jp/api/search',
          type: 'GET',
          dataType: 'json',
          data: {
            zipcode: postalCode
          },
          success: function(data) {
            if (data.results && data.results.length > 0) {
              const result = data.results[0];
              const address = result.address1 + result.address2 + (result.address3 || '');
              $addressInput.val(address);
            } else {
              console.log('該当する住所が見つかりませんでした');
            }
          },
          error: function() {
            console.log('郵便番号検索でエラーが発生しました');
          }
        });
      }
    });
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const instaSwiper = new Swiper(".c-swiper-insta", {
      slidesPerView: 'auto',
      spaceBetween: 6,
      speed: 13000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 20,
        }
      },
    });

    const messageSwiper = new Swiper('.c-message-swiper', {
      slidesPerView: 1,
      loop: true,
      speed: 600,
    
      navigation: {
        nextEl: '.c-swiper-message-next',
        prevEl: '.c-swiper-message-prev',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    
      allowTouchMove: true,
    });
    

    const totalSlides =
    messageSwiper.slides.length - messageSwiper.loopedSlides * 2;
    document.querySelector('.c-swiper-message-total').textContent = String(totalSlides).padStart(2, '0');
  

    messageSwiper.on('slideChange', () => {
      const index = messageSwiper.realIndex + 1;
      document.querySelector('.c-swiper-message-current').textContent =
        String(index).padStart(2, '0');
    });


    $('.js-acc-content').hide();
    $('.js-acc-trigger').click(function() {
      $(this).next().slideToggle();
      $(this).find('.ic-plus').toggleClass('is-active');
    })

    var mvSwiper = new Swiper(".c-mv-swiper", {
      slidesPerView: 1,
      loop: true,
      speed: 2000,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
    
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-h-content a').on('click', function() {
        $('html').removeClass('is-open');
        scrollBan();
      });
      $('.js-mega-trigger').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).find('.js-mega-plus').toggleClass('is-active');
        $(this).children('.js-mega-content').slideToggle();
      });
    } else {
      $('.js-mega-trigger').hover(function() {
        $(this).addClass('is-active');
        $(this).children('.js-mega-content').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active'); 
        $(this).children('.js-mega-content').removeClass('is-active');
      });

      $('.js-mega-content').hover(function() {
        $(this).addClass('is-active');
        $(this).parent('.js-mega-trigger').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).parent('.js-mega-trigger').removeClass('is-active');
      });
    }
    
    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    let scrollTop = 0;

    function scrollBan() {
      const body = $('html')[0];
      if (body.classList.contains('is-hidden')) {
        body.style.scrollBehavior = 'auto';
        body.style.top = '';
        body.classList.remove('is-hidden');
        window.scrollTo(0, scrollTop);
        setTimeout(() => body.style.scrollBehavior = 'smooth', 0);
      } else {
        scrollTop = window.scrollY;
        body.style.top = (scrollTop * -1) + 'px';
        body.classList.add('is-hidden');
      }
    }
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBanOpen();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBanClase();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  // スクロール禁止
  if(body.classList.contains('is-hidden')){
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
    $('html').css({'scroll-behavior': 'smooth'})
  } else {
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
    $('html').css({'scroll-behavior': 'inherit'})
  }
}
class TopElementor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-elementor-drawer-trigger').on('click', function(){
      $('html').toggleClass('is-elementor-drawer-open');
      scrollBan();
    });

    let scrollTimer;
    $(window).on('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        if($(window).scrollTop() > 100) {
          $('html').addClass('is-scroll');
        } else {
          $('html').removeClass('is-scroll');
        }
      }, 100);
    });

  }
}


// ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
window.addEventListener('load', () => {
  setTimeout(() => {
    $('.js-loading').fadeOut();
  }, 1500);
});

(() => {

  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let headerMenu = new HeaderMenu('js-header');
  
  // ------------------------------
  // トップページ用
  // ------------------------------
  let top = new Top('p-top');
  let simulation = new Simulation('p-simulation');
  let order = new Order('p-order');
  
  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let topElementor = new TopElementor('js-topElementor');
  let modal = new Modal('js-modal');
  let accordion = new Accordion('js-accordion');
  let editor = new Editor('c-content');
  let contact = new Contact('p-contact');

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});